export enum AppLoginOutcome {
    Success = 1,
    UnknownUsername = 2,
    UserLockedOut = 3,
    WrongPassword = 4,
    UserDeleted = 5,
    UserInactive = 6,
    Remembered = 7,
    EmailMismatch = 8,
    IncorrectEmail = 9
};
